export default "__VITE_ASSET__CjumQazS__"